/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventPeopleRendererQueryVariables = {
    orgRelayId: string;
    eventCalendarId: string;
    externalEventId: string;
    timeZone: string;
    personCalendarIds: Array<string | null>;
};
export type EventPeopleRendererQueryResponse = {
    readonly org: {
        readonly " $fragmentRefs": FragmentRefs<"EventPeople_org">;
    } | null;
};
export type EventPeopleRendererQuery = {
    readonly response: EventPeopleRendererQueryResponse;
    readonly variables: EventPeopleRendererQueryVariables;
};



/*
query EventPeopleRendererQuery(
  $orgRelayId: ID!
  $externalEventId: String!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...EventPeople_org_19BGbP
    }
    id
  }
}

fragment AvatarPerson_org on Org {
  id
}

fragment EventPeople_org_19BGbP on Org {
  ...AvatarPerson_org
  id
  experiments
  computeCurrentSlotImpactErrorable(externalEventId: $externalEventId) {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on CurrentScheduledSlotImpact {
      currentSlot {
        summary {
          conflictingAttendees
          unavailableAttendees
          inconvenientForAttendees
          focusTimeMinutesCost
        }
        attendanceImpacts {
          hasConflict
          calendarId
          focusTimeMinutesCost
          inconveniences
          unavailabilities
          conflictingMeetings
        }
      }
      uncrawledCalendars
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "eventCalendarId"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "externalEventId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "personCalendarIds"
    } as any, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "timeZone"
    } as any, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v6 = {
        "kind": "Variable",
        "name": "externalEventId",
        "variableName": "externalEventId"
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "focusTimeMinutesCost",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "EventPeopleRendererQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v5 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "eventCalendarId",
                                            "variableName": "eventCalendarId"
                                        },
                                        (v6 /*: any*/),
                                        {
                                            "kind": "Variable",
                                            "name": "personCalendarIds",
                                            "variableName": "personCalendarIds"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "timeZone",
                                            "variableName": "timeZone"
                                        }
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "EventPeople_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v2 /*: any*/),
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v4 /*: any*/),
                (v3 /*: any*/)
            ],
            "kind": "Operation",
            "name": "EventPeopleRendererQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v5 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v7 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "experiments",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        (v6 /*: any*/)
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "computeCurrentSlotImpactErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "statusCode",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "message",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SchedulingSlot",
                                                    "kind": "LinkedField",
                                                    "name": "currentSlot",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SchedulingAttendanceSummary",
                                                            "kind": "LinkedField",
                                                            "name": "summary",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "conflictingAttendees",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "unavailableAttendees",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "inconvenientForAttendees",
                                                                    "storageKey": null
                                                                },
                                                                (v8 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SchedulingAttendanceImpact",
                                                            "kind": "LinkedField",
                                                            "name": "attendanceImpacts",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "hasConflict",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "calendarId",
                                                                    "storageKey": null
                                                                },
                                                                (v8 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "inconveniences",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "unavailabilities",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "conflictingMeetings",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "uncrawledCalendars",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "CurrentScheduledSlotImpact",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "5b63e1542a0e39afe6d7e9750ab5586e",
            "id": null,
            "metadata": {},
            "name": "EventPeopleRendererQuery",
            "operationKind": "query",
            "text": "query EventPeopleRendererQuery(\n  $orgRelayId: ID!\n  $externalEventId: String!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...EventPeople_org_19BGbP\n    }\n    id\n  }\n}\n\nfragment AvatarPerson_org on Org {\n  id\n}\n\nfragment EventPeople_org_19BGbP on Org {\n  ...AvatarPerson_org\n  id\n  experiments\n  computeCurrentSlotImpactErrorable(externalEventId: $externalEventId) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on CurrentScheduledSlotImpact {\n      currentSlot {\n        summary {\n          conflictingAttendees\n          unavailableAttendees\n          inconvenientForAttendees\n          focusTimeMinutesCost\n        }\n        attendanceImpacts {\n          hasConflict\n          calendarId\n          focusTimeMinutesCost\n          inconveniences\n          unavailabilities\n          conflictingMeetings\n        }\n      }\n      uncrawledCalendars\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'ea859600d2926f93128f7599a003ffb8';
export default node;
